module.exports = __webpack_public_path__ + "static/media/Patrocinio_comprar.ac385879.jpg";